import { render, staticRenderFns } from "./condAdminOrgSettings.vue?vue&type=template&id=2661f331&scoped=true"
import script from "./condAdminOrgSettings.vue?vue&type=script&lang=js"
export * from "./condAdminOrgSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2661f331",
  null
  
)

export default component.exports